import React, { useEffect } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";

const OutsideClick = ({ closeRef, func, state }) => {
  const closeModalByEsc = (e) => {
    if (e.keyCode === 27) func();
  };
  useOnClickOutside(closeRef, func);
  useEffect(() => {
    window.addEventListener("keydown", closeModalByEsc);
    return () => {
      window.removeEventListener("keydown", closeModalByEsc);
    };
  }, [state]);

  return <></>;
};

export default OutsideClick;
